import React from 'react'
import i18n from "i18next";
import {PatientInput} from "../components/PatientRequest";
import util from "../lib/chart_functions";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import Accordion from "../components/Accordion";
import { FiUsers } from 'react-icons/fi';
export default class PatientContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            response: '[]',
            status_code: 200,
            isLoading: true,
            isInitialLoad: true,
            headers: ["sex_pie", "age_hist"],
            fields: ["sex", "age"],
            functions: [util.make_pie_from_json_dict, util.make_hist_from_json_dict],
            lists: [],
            checkeds: [],
            // Available items based on current selection (from /filters/ endpoint)
            availableSex: new Set()
        };
    }

    // Fetch available filter options from /filters/ endpoint
    // For sex availability, we only apply age filter (not sex itself)
    fetchAvailableFilters = (filterState) => {
        const age_na = filterState.age_settings
            .filter((_, i) => filterState.age_settings_checked[i])
            .includes('age_na');
        const age_nb = filterState.age_settings
            .filter((_, i) => filterState.age_settings_checked[i])
            .includes('age_nb');

        // Only apply age filter to determine available sex values
        const params = new URLSearchParams({
            age_min: filterState.age[0],
            age_max: filterState.age[1],
            age_na: age_na,
            age_nb: age_nb
        });

        fetch(`${process.env.REACT_APP_BACK_END}/filters/?${params}`)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    availableSex: new Set(data.sex || [])
                });
            })
            .catch(error => {
                console.error('Error fetching available filters:', error);
            });
    }



    componentDidMount() {
        const headers = {'Access-Control-Request-Method': 'GET'}
        const params = new URLSearchParams({full: 'true'});
        this.handleFetch(`${process.env.REACT_APP_BACK_END}/patients/?${params.toString()}`, {headers}, true);
    }

    createNewRequest = (input) => {
        // If sex filter is empty, show "no results" without making request
        if (!input.sex_input) {
            this.setState({
                response: 'patients_zero',
                status_code: 200,
                isLoading: false
            });
            return;
        }

        const headers = {'Content-Type': 'application/json'}
        const params = new URLSearchParams({
            sex: input.sex_input,
            age_min: input.age[0],
            age_max: input.age[1],
            age_na: input.age_settings_input.includes('age_na'),
            age_nb: input.age_settings_input.includes('age_nb')
        });
        this.handleFetch(`${process.env.REACT_APP_BACK_END}/patients/?${params.toString()}`, {headers});

    }

    handleFetch = (url, options, isInitial = false) => {
        this.setState({isLoading: true});
        fetch(url, options)
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => {
                const newState = {response: data, isLoading: false};

                // Only initialize checkeds on initial load
                if (isInitial) {
                    try {
                        const parsed = JSON.parse(data);
                        const selectors = parsed.selectors || {};
                        const lists = {};
                        const checkeds = {};

                        lists['age_settings_list'] = ['age_na', 'age_nb'];
                        checkeds['age_settings_list'] = [true, true];

                        const sexList = selectors['sex_list'] || [];
                        lists['sex_list'] = sexList;
                        checkeds['sex_list'] = Array(sexList.length).fill(true);

                        newState.lists = lists;
                        newState.checkeds = checkeds;
                        newState.isInitialLoad = false;

                        // Initially all items are available
                        newState.availableSex = new Set(lists['sex_list'] || []);
                    } catch (e) {
                        console.error('Error parsing initial response:', e);
                    }
                }

                this.setState(newState);
            })
            .catch(error => this.setState({status_code: 500, response: error.message, isLoading: false}));
    }

    renderPageHeader = () => (
        <div className="page-header mb-4">
            <h1 className="page-title">
                <FiUsers size={28} />
                {i18n.t('patients_title')}
            </h1>
            <p className="page-description">{i18n.t('patients_description')}</p>
        </div>
    )

    render() {
        const {response} = this.state
        const {status_code} = this.state
        let {lists} = this.state
        let {checkeds} = this.state
        const {headers} = this.state
        const {fields} = this.state
        const {functions} = this.state
        const {isLoading} = this.state

        const htmls = []
        let L = 0
        const ERRORS = ["assays_zero", "patients_zero", "organizations_zero", "collections_zero", "merge_zero"]

        const { availableSex } = this.state;

        if (isLoading) {
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        <PatientInput createNewRequest={this.createNewRequest}
                                      onFilterChange={this.fetchAvailableFilters}
                                      sex={[]}
                                      sex_checked={[]}
                                      age_settings={['age_na', 'age_nb']}
                                      age_settings_checked={[true, true]}
                                      length_objects={0}
                                      availableSex={availableSex}
                        />
                    </div>
                    <div className="col-8">
                        <LoadingSpinner message="loading_data" size="md" />
                    </div>
                </div>
            </div>);
        }

        if (status_code !== 200) {
            const errorType = status_code >= 500 ? 'error_server' : 'error_network';
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        <PatientInput createNewRequest={this.createNewRequest}
                                      onFilterChange={this.fetchAvailableFilters}
                                      sex={lists['sex_list'] || []}
                                      sex_checked={checkeds['sex_list'] || []}
                                      age_settings={lists['age_settings_list'] || ['age_na', 'age_nb']}
                                      age_settings_checked={checkeds['age_settings_list'] || [true, true]}
                                      length_objects={0}
                                      availableSex={availableSex}
                        />
                    </div>
                    <div className="col-8">
                        <ErrorMessage
                            type="error"
                            message={errorType}
                            details={`Status: ${status_code}`}
                            onRetry={() => this.componentDidMount()}
                        />
                    </div>
                </div>
            </div>);
        }

        if (ERRORS.includes(response)) {
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        <PatientInput createNewRequest={this.createNewRequest}
                                      onFilterChange={this.fetchAvailableFilters}
                                      sex={lists['sex_list'] || []}
                                      sex_checked={checkeds['sex_list'] || []}
                                      age_settings={lists['age_settings_list'] || ['age_na', 'age_nb']}
                                      age_settings_checked={checkeds['age_settings_list'] || [true, true]}
                                      length_objects={0}
                                      availableSex={availableSex}
                        />
                    </div>
                    <div className="col-8">
                        <Accordion>
                            <Accordion.Item
                                title={i18n.t("found_patients")}
                                badge={0}
                                defaultOpen={true}
                            >
                                <p className="empty-state">
                                    {i18n.t("no_results_found")}
                                </p>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>);
        }

        // Success case - parse and display data
        const parsed_json = JSON.parse(response)
        const patients = parsed_json["patients"]

        if (typeof patients !== 'undefined') {
            for (const i in fields) {
                let chart = null
                if (fields[i] !== "age") {
                    chart = functions[i](patients[fields[i]], i18n.t(headers[i]), `${fields[i]}_`)
                } else {
                    chart = functions[i](patients[fields[i]], i18n.t(headers[i]), "")
                }
                htmls.push(
                    <Accordion.Item
                        key={`chart-${i}`}
                        title={i18n.t(headers[i])}
                        defaultOpen={true}
                    >
                        {chart}
                    </Accordion.Item>
                )
            }
        }

        L = parsed_json['patient_n'];

        return (<div className="main-container container">
            {this.renderPageHeader()}
            <div className="row">
                <div className="col-4">
                    <PatientInput createNewRequest={this.createNewRequest}
                                  onFilterChange={this.fetchAvailableFilters}
                                  sex={lists['sex_list']}
                                  sex_checked={checkeds['sex_list']}
                                  age_settings={lists['age_settings_list']}
                                  age_settings_checked={checkeds['age_settings_list']}
                                  length_objects={L}
                                  availableSex={availableSex}
                    />
                </div>
                <div className="col-8">
                    <Accordion>
                        {htmls}
                    </Accordion>
                </div>
            </div>
        </div>);
    }

}
